import { useEffect, useState } from 'react';
import agent from '../../../api/agent';
import { Menu } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../../stores/store';
import LoadingComponent from '../../../layout/LoadingComponent';

function SmartFlowList() {
  const {
    commonStore,
    dashboardStore,
    userStore: { user },
  } = useStore();

  const history = useNavigate();

  const [list, setList] = useState<
    {
      id: string;
      name: string;
    }[]
  >([]);

  useEffect(() => {
    (async () => {
      if (
        user?.customerName !== 'NFAI' ||
        window.innerWidth > 1025 ||
        window.innerWidth < 1020
      ) {
        let assetResult = await agent.AssetTypes.smartflowTemplate();
        setList(assetResult.data || []);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const clickHandler = (id: string) => {
    let ids = id.split('_');
    let routeId = `/smart_flow/asset/${ids[0]}/element/${ids[1]}/template/${ids[2]}`;
    history(routeId);
  };

  return (
    <div
      className={
        commonStore.filterModeZero.includes('SMF01')
          ? 'component-isDisabled'
          : ''
      }
    >
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}

      {!!list?.length && commonStore.filterModeOne?.includes('SMF01') && (
        <Menu.Item name="Smart Flow">
          Smart Flow
          <div
            style={{
              maxHeight: '300px',
              overflowY: 'scroll',
              margin: '12px 0',
            }}
          >
            <Menu.Menu>
              {list.map((data) => (
                <Menu.Item
                  key={data.name}
                  disabled={commonStore.filterModeZero.includes(data.id)}
                  name={data.name}
                  style={{
                    color: '#616161',
                    cursor: 'pointer',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                  }}
                  onClick={() => clickHandler(data.id)}
                >
                  {data.name}
                </Menu.Item>
              ))}
            </Menu.Menu>
          </div>
        </Menu.Item>
      )}
    </div>
  );
}

export default SmartFlowList;
